import { Grid, Card, Skeleton } from '@mui/material';
import JobOfferCard from '@modules/JobOffers/JobOfferCard';
import { EmptyState } from '@components/DataTable';

interface TalentListGridProps {
    cardMenuList: {
        id: number;
        title: string;
        icon: React.ElementType;
        type: string;
        style?: string;
    }[];
    data: any[];
    onConfirm: (params: { title: string; description: string }) => void;
    loading: boolean;
    setSelectedId: (id: string) => void;
}

const JobOfferGrid = ({ cardMenuList, data, onConfirm, loading, setSelectedId }: TalentListGridProps) => {
    return (
        <Grid container spacing={2} minHeight="calc(100dvh - 505px)">
            {loading &&
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(val => (
                    <Grid item xs={12} sm={6} md={4} key={val}>
                        <Card sx={{ width: '350.66px', height: '278.66px' }}>
                            <Skeleton variant="rectangular" width="100%" height="100%" />
                        </Card>
                    </Grid>
                ))}

            {!loading && data?.length === 0 && (
                <Grid item xs={12}>
                    <EmptyState
                        title="Nous n'avons actuellement aucune offre d'emploi"
                        subtitle="Commençons à inviter de nouveaux talents à s'inscrire à Uppercut."
                    />
                </Grid>
            )}

            {!loading &&
                data?.length > 0 &&
                data.map(jobOffer => {
                    return (
                        <Grid item xs={12} sm={6} md={4} key={jobOffer._id}>
                            <JobOfferCard
                                job={jobOffer}
                                onConfirm={onConfirm}
                                setSelectedId={setSelectedId}
                            />
                        </Grid>
                    );
                })}
        </Grid>
    );
};

export default JobOfferGrid;
